export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities64.003d92ab.svg";